// React
import React, { useState } from "react";

// External libraries
import {faClipboard, faClipboardCheck} from "@fortawesome/sharp-solid-svg-icons";

// Internal
import {InputCopyButton} from "./input-clipboard-copy-button";
import {InputErrorIndicator} from "./input-error-indicator";
import {InputIcon} from "./input-icon";

const GUID_CHAR_REGEX = /[0-9A-F]/;

const formatGuid = function (value) {
    if (!value) return "";
    const length = value.length;
    value = value.replace(/-/g, "").substring(0, 32).padEnd(32, "0");
    const guid = value.match(/([0-9A-F]{8})([0-9A-F]{4})([0-9A-F]{4})([0-9A-F]{4})([0-9A-F]{12})/i);
    if (guid) {
        if (length <= 8) {
            return guid[1].substring(0, length);
        }
        if (length <= 12) {
            return guid[1].concat("-", guid[2]).substring(0, length + 1);
        }
        if (length <= 16) {
            return guid[1].concat("-", guid[2], "-", guid[3]).substring(0, length + 2);
        }
        if (length <= 20) {
            return guid[1].concat("-", guid[2], "-", guid[3], "-", guid[4]).substring(0, length + 3);
        }
        return guid[1].concat("-", guid[2], "-", guid[3], "-", guid[4], "-", guid[5]).substring(0, length + 4);
    }
    return "";
};

function InputGuid(props) {
    const [errorMessage, setErrorMessage] = useState("");
    const [copied, setCopied] = useState(false);
    const [focused, setFocused] = useState(false);
    
    const changeHandler = (e) => {
        let value = "";
        for (let i = 0; i < e.target.value.length; i++) {
            const testChar = e.target.value.charAt(i).toUpperCase();
            if (GUID_CHAR_REGEX.test(testChar)) {
                value = value + testChar;
            }
        }
        if (typeof props.OnChange === "function") {
            props.OnChange(value);
        }
    };

    const blurHandler = (e) => {
        setFocused(false);
        if (typeof props.OnBlur === "function") {
            props.OnBlur(e.target.value);
        }
    };

    const focusHandler = (e) => {
        setFocused(true);
        const temp_value = e.target.value;
        e.target.value = "";
        e.target.value = temp_value;
        if (typeof props.OnFocus === "function") {
            props.OnFocus();
        }
    };

    const getValue = () => {
        const formattedValue = formatGuid(props.Value);
        return formattedValue;
    };

    const copyToClipboard = async () => {
        setCopied(true);
        setTimeout(clearCopiedState, 5000);
        await navigator.clipboard.writeText(props.Value);
    };

    const clearCopiedState = () => {
        setCopied(false);
    };

    const getClipboardIcon = () => {
        return copied ? faClipboardCheck : faClipboard;
    };

    const getContainerClass = () => {
        if (props.ContainerClass) {
            return props.ContainerClass;
        }
        if (focused) {
            return "eone-ui-input-container eone-ui-input-container-focused";
        }
        return "eone-ui-input-container";
    };

    if (props.Visible !== undefined && !props.Visible) {
        return null;
    }

    return (
        <div className={getContainerClass()}>
            <InputIcon Icon={props.Icon} DataTestId={props.DataTestId}/>
            <input
                className="eone-ui-input-string"
                id={props.Id}
                autoFocus={props.AutoFocus}
                onBlur={blurHandler}
                onChange={changeHandler}
                onFocus={focusHandler}
                type="text"
                placeholder="00000000-0000-0000-0000-000000000000"
                value={getValue()}
                data-testid={props.DataTestId}/>
            <InputCopyButton
                Show={props.ShowCopyButton}
                Icon={getClipboardIcon()}
                Copy={copyToClipboard}
                DataTestId={props.DataTestId}/>
            <InputErrorIndicator
                Error={errorMessage || props.ErrorMessage}
                DataTestId={props.DataTestId}/>
        </div>
    );

}

export {InputGuid};